import { render, staticRenderFns } from "./GeneralOCR.vue?vue&type=template&id=ab1645a8&"
import script from "./GeneralOCR.vue?vue&type=script&lang=js&"
export * from "./GeneralOCR.vue?vue&type=script&lang=js&"
import style0 from "./GeneralOCR.vue?vue&type=style&index=0&id=ab1645a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports